/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HousewareSoapLiquidIcon16Solid = forwardRef('HousewareSoapLiquidIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0a.75.75 0 0 0 0 1.5h1.25V3h-.5c-.69 0-1.25.56-1.25 1.25v1.837A3.251 3.251 0 0 0 3 9.25V13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9.25a3.251 3.251 0 0 0-2.5-3.163V4.25C10.5 3.56 9.94 3 9.25 3h-.5V1.5h1.289c.38 0 .739.173.976.47l.4.499a.75.75 0 0 0 1.17-.938l-.399-.499A2.75 2.75 0 0 0 10.04 0H6Zm3 6V4.5H7V6h2Z" })));
});
